import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-passeio',
  templateUrl: './passeio.component.html',
  styleUrls: ['./passeio.component.css']
})
export class PasseioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
